import { createStyles } from "@busbud/design-system-components/dist/styles/createStyles";

export const useStyles = createStyles(({ theme }) => {
  const { colors } = theme.busbud;

  return {
    tabs: {
      // [dscl-override] Tabs
      // https://github.com/busbud/design-system/issues/1164
      // TODO: remove after adding ability to the `Tabs` having border in `full-width` variant
      boxShadow: `inset 0 -1px 0 ${colors.border.primary.opaque}`
    },
    tab: {
      // [dscl-override] Tab
      // TODO: remove after adding ability to the `Tab` disabling minimun width for the button
      // https://github.com/busbud/design-system/issues/1165
      minWidth: "auto"
    },
    withoutBorder: {
      boxShadow: "initial"
    }
  };
});
